import { uniqWith } from 'lodash';

export const uniqueResourcesByUserAndEmployer = (resources) => {
  const resourcesWithEmployer = [];

  const resourcesWithoutEmployer = [];

  resources.forEach((resource) => {
    if (resource.employerBusinessId) {
      resourcesWithEmployer.push(resource);
    } else {
      resourcesWithoutEmployer.push(resource);
    }
  });

  const uniqueResourcesWithEmployer = uniqWith(
    resourcesWithEmployer,
    (a, b) => a.user === b.user && a.employerBusinessId === b.employerBusinessId
  );

  const uniqueResourcesRecordResourcesWithoutEmployer = uniqWith(
    resourcesWithoutEmployer,
    (a, b) => a.user === b.user
  );

  const uniqueResources = [
    ...uniqueResourcesWithEmployer,
    ...uniqueResourcesRecordResourcesWithoutEmployer,
  ];

  return uniqueResources;
};
